<template>
  <div class="sets-report-wrapper">
    <div class="contentSection custom-padding mb-3 mt-0">
      <div id="chart"></div>
    </div>
    <div class="col-md-12">
      <div class="row">
          <BaseIconSelect
            customClass="col-md-3"
            :icon="{ css: 'fas fa-calendar'}"
            v-model="selectedReportDate"
            @select="(value) => { getSetsReport(value) }"
            :items="[
              { name: 'Today', value: 'today'},
              { name: 'Last 7 Days', value: 'last7days'},
              { name: 'Month To Date', value: 'monthToDate'}]"/>
          <BaseIconSelect
            v-if="setsReport"
            customClass="col-md-3"
            :icon="{ css:'fas fa-eye' }"
            v-model="selectedChartOption"
            @select="(value) => (renderChart(selectedChartOption.name, selectedChartOption.value))"
            :items="[
              { name: 'Revenue', value: 'revenue'},
              { name: 'Conversion Rate', value: 'conversion_rate'},
              { name: 'Views', value: 'views'}]"/>
        <BaseSearchInput customClass="col-md-3 offset-md-3" @searchterm="searchSetsReport($event)"/>
    </div>
  </div>
    <BaseTable
      :columns="columns"
      :tableData="setsReportForTable"
      :pagination="{}"
      :paginationParams="{}"
      :downloadCsv="true"
      :totals="true"
      :indexCallback="function(){}">
      <span slot="rpu" slot-scope="{row}">
        {{ (row.revenue / row.views ) | currency }}
      </span>
    </BaseTable>
  </div>
</template>
<script>
// import Sets from '@/resources/Sets.js'
import Reports from '@/resources/TrackingReports.js'
import BarChart from '@/lib/charts/BarChart.js'
import moment from 'moment'

var setsReport

export default {
  data () {
    return {
      sets: [],
      setsReport: [],
      setsReportForTable: [],
      columns: [
        { name: 'Set Name', key: 'name', class: 'col-md-3' },
        { name: 'Offers', key: 'offer_count', class: 'col-md-1' },
        { name: 'Users', key: 'views', class: 'col-md-1', filter: 'number' },
        { name: 'Completions', key: 'completions', class: 'col-md-2', filter: 'number' },
        { name: 'Conv %', key: 'conversion_rate', class: 'col-md-1', filter: 'percentage' },
        { name: 'O Views', key: 'offer_views', class: 'col-md-1', filter: 'number' },
        { name: 'O Clicks', key: 'offer_yes_clicks', class: 'col-md-1', filter: 'number' },
        { name: 'RPU', key: 'rpu', class: 'col-md-1' },
        { name: 'Revenue', key: 'revenue', class: 'col-md-1', filter: 'currency' }
      ],
      index: {
        limit: 10,
        page: 1,
        total: null
      },
      totals: {},
      pagination: {},
      // selectedReportDate: { name: 'Today', value: 'today' },
      selectedReportDate: { name: 'Today', value: 'today' },
      selectedChartOption: { name: 'Views', value: 'views' }
    }
  },
  mounted () {
    //
  },
  methods: {
    searchSetsReport (event) {
      this.setsReport = []
      this.setsReportForTable = []
      setsReport.filter((offer) => {
        if (offer.name.toLowerCase().includes(event.search.toLowerCase())) {
          this.setsReport.push(offer)
          this.setsReportForTable.push(offer)
        }
      })
      this.totals = this.calculateTotals(this.setsReportForTable)
      this.setsReportForTable.push(this.totals)
      this.renderChart(this.selectedChartOption.name, this.selectedChartOption.value)
    },
    setDateRange (date) {
      let dateRange = {}
      dateRange['start_date'] = moment.utc().startOf('day').format('YYYY-MM-DD HH:mm:ss')
      dateRange['end_date'] = moment.utc().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      switch (date.value) {
        case 'today':
          dateRange['start_date'] = moment.utc().startOf('day').format('YYYY-MM-DD HH:mm:ss')
          dateRange['end_date'] = moment.utc().endOf('day').format('YYYY-MM-DD HH:mm:ss')
          break
        case 'monthToDate':
          dateRange['start_date'] = moment.utc().startOf('month').format('YYYY-MM-DD HH:mm:ss')
          dateRange['end_date'] = moment.utc().endOf('month').format('YYYY-MM-DD HH:mm:ss')
          break
        case 'last7days':
          dateRange['start_date'] = moment.utc().subtract('7', 'd').format('YYYY-MM-DD HH:mm:ss')
          dateRange['end_date'] = moment.utc().endOf('date').format('YYYY-MM-DD HH:mm:ss')
          break
      }
      return dateRange
    },
    calculateTotals (data) {
      let totals = {
        'name': 'Totals',
        'views': 0,
        'completions': 0,
        'conversion_rate': 0,
        'offer_views': 0,
        'offer_yes_clicks': 0,
        'rpu': 0,
        'revenue': 0
      }
      let percentages = []
      for (let i = 0; i < data.length; i++) {
        const item = data[i]
        for (const key in item) {
          if (item.hasOwnProperty(key)) {
            const field = item[key]
            switch (key) {
              case 'conversion_rate':
                percentages.push(parseFloat(field))
                break
              case 'name':
                // do nothing
                break
              case 'views':
                totals[key] += parseFloat(field)
                break
              case 'offer_views':
                totals[key] += parseFloat(field)
                break
              case 'offer_yes_clicks':
                totals[key] += parseFloat(field)
                break
              case 'revenue':
                totals[key] += parseFloat(field)
                break
              case 'completions':
                totals[key] += parseFloat(field)
                break
              case 'rpu':
                totals[key] += parseFloat(field)
                break
              default:
                totals[key] = '-'
                break
            }
          }
        }
      }
      totals['conversion_rate'] = this.findAveragePercentage(percentages)
      return totals
    },
    findAveragePercentage (one, two) {
      if (!one) return two
      one = (one / 100)
      two = (two / 100)
      let total = two + one
      total = total / 2
      return total * 100
    },
    getSetsReport (dateRange) {
      Reports.sets(this.setDateRange(dateRange))
        .then((response) => {
          setsReport = response
          this.setsReport = response
          this.setsReportForTable = JSON.parse(JSON.stringify(response))
          this.totals = this.calculateTotals(response)
          this.setsReportForTable.push(this.totals)
          this.renderChart('Views', 'views')
        })
    },
    buildDataForChart (data, name, type) {
      let barData = []
      let categories = []
      for (var i = 0; i < data.length; i++) {
        let set = data[i]
        barData.push(parseFloat(set[type]))
        categories.push(set.name)
      }
      return {
        data: [
          { name: name, data: barData }
        ],
        categories: categories
      }
    },
    renderChart (name, type) {
      let dataType = null
      let chartData = this.buildDataForChart(this.setsReport, name, type)
      if (type === 'conversion_rate') dataType = 'percentage'
      if (type === 'revenue') dataType = 'currency'
      let options = {
        name: name,
        dataType: dataType,
        categories: chartData.categories
      }
      BarChart.build(chartData.data, options, '#chart')
    }
  }
}
</script>
<style lang="scss" scoped>
.sets-report-wrapper {
  .custom-padding {
    border-radius: 0px 0px 6px 6px;
  }
  margin: 0px;
  .input-group {
    flex-wrap: nowrap;
    padding: 0px;
    span,
    .input-group-text {
      background-color: $container-bg;
    }
    .input-group-prepend,
    .input-group-text {
      max-width: 50px;
      i:before {
        margin: 0px;
      }
    }
  }
}
</style>
